import { useTranslation } from "react-i18next";
import { useState } from "react";
import BackButtonWrapper from "../../../components/button/BackButton/wrapper";
import { ExportBlacklistingReportForExcelPDFBody } from "../../../hooks/report/interface";
import { PAGE_SIZE } from "../../../constants/common";
import SearchBlacklistingReportCard from "../../../components/card/SearchBlacklistingReportCard";
import BlacklistingReportTable from "../../../components/table/BlacklistingReportTable";

const BlacklistingReport = () => {
  const { t } = useTranslation();

  const [exportBody, setExportBody] =
    useState<ExportBlacklistingReportForExcelPDFBody>();
  const [page, setPage] = useState<number>(1);
  const [pages, setPages] = useState(1);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState<number>(PAGE_SIZE);

  const [allBlacklisting, setAllBlacklisting] = useState([]);

  return (
    <div className="flex flex-col gap-4 md:gap-8">
      <BackButtonWrapper>
        <h1 className="text-xl md:text-2xl dark:text-white">
          {t("blacklistingReport")}
        </h1>
      </BackButtonWrapper>

      <SearchBlacklistingReportCard
        setAllBlacklisting={setAllBlacklisting}
        page={page}
        setPages={setPages}
        setCount={setCount}
        setExportBody={setExportBody}
        pageSize={pageSize}
        setPage={setPage}
      />

      <BlacklistingReportTable
        allBlacklisting={allBlacklisting}
        page={page}
        pages={pages}
        setPage={setPage}
        count={count}
        exportBody={exportBody}
        pageSize={pageSize}
        setPageSize={setPageSize}
      />
    </div>
  );
};

export default BlacklistingReport;
